import React from "react";
import { useTheme } from "@mui/material";
import { ThemeProvider } from "@odl/core";
import PostHogProvider from "components/PostHog/PostHogProvider";
import RouteController from "components/RouteController/RouteController";
import GlobalStyles from "styles/GlobalStyles";
import ThemeModeContext from "components/ThemeModeProvider/ThemeModeContext";
import { themeOverride } from "styles/themeOverride";
import themeComponentOverride from "styles/themeComponentOverride";
import AppLayoutProvider from "contexts/AppLayoutProvider";

const App = () => {
  const theme = React.useContext(ThemeModeContext);

  const muiTheme = useTheme();

  return (
    <ThemeProvider
      mode={theme?.mode}
      brand="planbuild"
      theme={{ ...themeOverride(muiTheme) }}
      componentThemeOverrides={themeComponentOverride}
    >
      <GlobalStyles />
      <PostHogProvider>
        <AppLayoutProvider>
          <RouteController />
        </AppLayoutProvider>
      </PostHogProvider>
    </ThemeProvider>
  );
};

export default App;
